export enum ECategoriesThemes {
  teal = 'teal',
  blue = 'blue',
  green = 'green',
  yellow = 'yellow',
  violet = 'violet',
}

export interface ICategory {
  title: string
  path: string
  theme: ECategoriesThemes
  list: ICategoryListItem[]
}

export interface ICategoryListItem {
  title: string
  description: string
  path: string
  id?: string
  codeId: string
}

export interface ICategoryAPI {
  id: string
  categoryName: string
  theme: string
  order: number
}

export interface ISubCategoryAPI {
  id: string
  subCategoryName: string
  subCategoryDescription: string
  order: number
  categoryId: string
  codeId: string
}

export interface ICategoryThemeSetting {
  name: ECategoriesThemes
  gradient: string[]
  guidance: string
  policies: string
  tooltipPreview: {
    borderColor: string
    shadowColor: string
  }
}
